module.exports = __webpack_public_path__ + "assets/img/00055.8de29628.png";